<template>
  <DialogTemplate
    :contentStretch="true"
    :contentStyle="'margin:0;padding:0!important'"
  >
    <div
      class="f-column"
      style="gap: 0.25rem; padding: 2rem 1rem 0 1rem"
    >
      <div class="text_tab_small">
        {{ $t(`common.actions`) }}
      </div>
      <HorizontalChart
        :legendRaiseFirst="true"
        :limitLegendTo="9999"
        :grouping="grouping"
        :hasLegend="true"
        :freKey="'total_frequency'"
        :skeleton="!solution_picked"
        :solution="solution_picked"
        :useHex="useHex"
        :activeActions="filterCombos.actions"
        :readOnly="false"
        :showBetsIn="showBetsIn"
        @action:click="handleActionClick"
      />
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click.stop="$store.dispatch('router_reset_dialogs')"
        >{{ $t('btn.close') }}</v-btn
      >
    </template>
  </DialogTemplate>
</template>

<script>
import HorizontalChart from '@/components/Charts/HorizontalChart/HorizontalChart'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import { toggleArrByKey } from '@/helpers/helpers'

export default {
  name: 'StudyMobileGraphDialog',
  components: {
    HorizontalChart,
    DialogTemplate,
  },
  props: {},
  methods: {
    handleActionClick(action) {
      let res = this.filterCombos.actions
      res = toggleArrByKey({
        arr: res,
        items: action.actions,
        item: action,
        key: 'code',
      })
      this.$store.dispatch('sol_filters_apply', { key: 'actions', value: res })
    },
  },
  computed: {
    filterCombos() {
      return this.$store.getters.sol_filter_combos
    },
    solution_picked() {
      return this.$store.getters.sol_data_solution_picked
    },
    useHex() {
      return this.$store.getters.sw_actions_grouping === 'swv_grouping_none'
    },
    grouping() {
      return this.$store.getters.sw_actions_grouping
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    showEvIn() {
      return this.$store.getters.show_ev_in
    },
  },
}
</script>

<style lang="scss" scoped>
.sws-title {
  font-size: var(--subtitle);
  color: var(--clr-white-0);
  color: var(--clr-grey-2);
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}
</style>
